import React from 'react';
import { Form, FormControl as Input, InputGroup } from 'react-bootstrap';
import Attention from './Attention';

export default function QuestionWeightField({ value, onChange }) {
    return <InputGroup>
        <div className="flex fdcolumn flex1 margin-bottom">
            <Form.Label htmlFor="question-weight">Peso da questão <Attention /></Form.Label>
            <Input id="question-weight" type="number" min="0" max="99999999.9999" step="0.0001" required
                placeholder="Peso da questão" value={value} aria-describedby="question-weight-help"
                onChange={event => { if (/^\d{0,8}(\.\d{0,4})?$/.test(event.target.value)) onChange(event.target.value); }} />
            <Form.Text id="question-weight-help" className="text-muted">Padrão: 1. Aceita até quatro casas decimais.</Form.Text>
        </div>
    </InputGroup>;
}
